import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/getting-started/quick-start.md?raw';

const SentryQuickStart: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default SentryQuickStart;
